<div class="comp-header">
  <div class="comp-header__inner">
    <h1 class="h3">Lokationer</h1>
    <button
      [admRequiresFeatureRole]="roles['charging-station-location.create']"
      (click)="openCreateLocationDialog()"
      mat-flat-button
      type="button">
      <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#location-s"></use></svg>
      Opret lokation
    </button>
  </div>
  <div>
    @if (state.focusedChargingStationLocation()) {
      @let focusedChargingStationLocation = state.focusedChargingStationLocation();
      <div class="comp-header__deeplinked">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
        Listen er filtreret til&nbsp;
        <strong>Lokation : {{ focusedChargingStationLocation?.name }}</strong>
        <button (click)="state.resetAllFilters()" class="actions__reset margin--left-m" mat-stroked-button>Nulstil</button>
      </div>
    } @else if (state.form.controls.priceRegulationIdentifier.value) {
      <div class="comp-header__deeplinked">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
        Listen er filtreret til prisregulering&nbsp;
        <strong>{{ state.form.controls.priceRegulationName.value ?? state.form.controls.priceRegulationIdentifier.value }}</strong>
        <button (click)="state.resetAllFilters()" class="actions__reset margin--left-m" mat-stroked-button>Nulstil</button>
      </div>
    } @else {
      <adm-charging-station-location-filters
        [searchText]="state.form.controls.query.value"
        [organizationId]="state.form.controls.organizationId.value ?? null"
        [departmentId]="state.form.controls.departmentId.value ?? null"
        [accessGroupIdentifier]="state.form.controls.accessGroupIdentifier.value ?? null"
        [pricePolicyId]="state.form.controls.pricePolicyId.value ?? null"
        [locationsWithErrorsInSetup]="state.form.controls.locationsWithErrorsInSetup.value"
        [resetTrigger]="state.resetAllFiltersTrigger()"
        [isPricePolicyViewer]="isPricePolicyViewer"
        (search$)="searchInput($event)"
        (organizationSelected)="onOrganizationSelected($event)"
        (departmentSelected)="onDepartmentSelected($event)"
        (accessGroupSelected)="onAccessGroupSelected($event)"
        (pricePolicySelected)="onPricePolicySelected($event)"
        (locationWithErrorFilterUpdated)="updateLocationWithErrorFilter($event)"
        (resetAllFilters)="state.resetAllFilters()" />
    }
  </div>
</div>
<div class="comp-main locations">
  <adm-charging-station-location-list
    [chargingStationLocationIdentifier]="state.form.controls.chargingStationLocationIdentifier.value ?? null"
    [activeChargingStationLocationIdentifier]="state.form.controls.chargingStationLocationIdentifier.value ?? null"
    [selectedPricePolicyId]="state.form.controls.pricePolicyId.value ?? null" />
</div>
